import { useEffect, useState } from 'react';
import copyMagicLog from 'common/components/CopyMagic/shared/copyMagicLog';
import fetchSuggestions, { FetchSuggestionsResponse } from '../../api/fetchSuggestions';

type SuggestionsQueryInput = {
  contextToken: string;
  pagePath: string;
  shouldFetch: boolean;
};

type OutcomeType = {
  data: FetchSuggestionsResponse | null;
  error: string | null;
};

const initialOutcome = {
  data: null,
  error: null,
};

const defaultErrorMessage = 'Oops! There was an error. Please refresh the page and try again.';
const unauthorizedError = 'Oops! Your session has expired. Please refresh the page and try again.';

const useSuggestionsQuery = ({ contextToken, pagePath, shouldFetch }: SuggestionsQueryInput) => {
  const [outcome, setOutcome] = useState<OutcomeType>(initialOutcome);

  useEffect(() => {
    if (!shouldFetch) {
      return;
    }

    fetchSuggestions({ contextToken, pagePath })
      .then((response) => {
        setOutcome({ data: response, error: null });
      })
      .catch((error) => {
        const errorStatus: number | undefined = error.response?.status;
        const errorMessage = errorStatus === 401 ? unauthorizedError : defaultErrorMessage;

        setOutcome({ data: null, error: errorMessage });
        copyMagicLog(error, { level: 'error' });
      });
  }, [contextToken, shouldFetch]); // eslint-disable-line react-hooks/exhaustive-deps

  return outcome;
};

export default useSuggestionsQuery;
